let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8AR1G")).then(() => parcelRequire('7JqCO'));